import React, { PureComponent } from 'react'
import { bool, any } from 'prop-types'
import './SectionActions.css'

export class SectionActions extends PureComponent {
    static propTypes = {
        show: bool.isRequired,
        children: any.isRequired
    }
    static defaultProps = {
        show: false
    }

    render() {
        const { show, children, className } = this.props
        return (
            <section className={['Actions', className, { Hide: !show }]}>
                <div className="flex row-right-bottom">
                    {children}
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Actions/SectionActions.js